import Phaser from 'phaser';
import { CST } from '../CST';
import { Score } from '../controller/score.js';

var pos = 0;

export default class Main_Storyboard extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.MAIN_STORYBOARD);
	}

	init() {
		pos = 0;
	}

	preload() {}

	create(data) {
		const map = this.add.image(0, 0, 'main-storyboard-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 7019); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.35); //0.8
		cam.centerOn(1100, 800); //1100, 800

		this.clickSound = this.sound.add('click-sound');

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.bgMusic.play();

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					//this.score.addPoints();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(1000, 950, 1000);
							cam.zoomTo(0.53, 1000);
							break;
						case 2:
							cam.pan(2900, 860, 1000);
							cam.zoomTo(0.51, 1000);
							break;
						case 3:
							cam.pan(2250, 2370, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 4:
							cam.pan(1100, 4000, 1000);
							cam.zoomTo(0.6, 1000);
							break;
						case 5:
							cam.pan(3200, 4050, 1000);
							cam.zoomTo(0.57, 1000);
							break;
						case 6:
							cam.pan(1100, 5945, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 7:
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.start(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
							});
							break;
						default:
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(1100, 800, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 1:
							cam.pan(1000, 950, 1000);
							cam.zoomTo(0.53, 1000);
							break;
						case 2:
							cam.pan(2900, 860, 1000);
							cam.zoomTo(0.51, 1000);
							break;
						case 3:
							cam.pan(2250, 2370, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 4:
							cam.pan(1100, 4000, 1000);
							cam.zoomTo(0.6, 1000);
							break;
						case 5:
							cam.pan(3200, 4050, 1000);
							cam.zoomTo(0.57, 1000);
							break;
						case 6:
							cam.pan(1100, 5945, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						default:
							break;
					}
				},
				this,
			);
	}
}
